import React, { MouseEventHandler, useState } from 'react';
import styles from './EmailForm.module.scss';
import { Button, Title, Group, TextInput, LoadingOverlay, Textarea, Space, Modal, Alert, Text } from '@mantine/core';
import { store } from '../../redux/store';
import { useForm } from '@mantine/form';
import { appActions, selectContactState,selectCurrentEmail,selectDomainCountry,selectValidTill } from '../../redux/appSlice';
import { useDispatch, useSelector } from 'react-redux';
import { sendEmail } from '../../services/api'
import { LinkComponet, InfoCircleRed } from '../icons/Icons';

import useStyles from '../../hooks/useStyles';
import useTranslation from '../../hooks/useTranslation';

type Props = {
  executeRecaptcha: any,
  children?: React.ReactNode,
  onCancel?: MouseEventHandler
}

function EmailForm({ executeRecaptcha, onCancel, children }: Props) {
  const [shareState, setShareState] = useState('not-ready')
  const dispatch = useDispatch()
  const currentEmail = useSelector(selectCurrentEmail)
  const validTillValue = useSelector(selectValidTill)
  const domainCountry = useSelector(selectDomainCountry)
  const validTill = new Date(validTillValue)
  const validDate = validTill.getDate() + '.' + (validTill.getMonth()+1) + '.' + validTill.getFullYear()
  const { classes } = useStyles()
  const t = useTranslation()

  const form = useForm({
    initialValues: {
      email: '',
      message: '',
    },
    validate: {
      email: (value) => (/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(value) ? null : t('ui-form-invalid-email')),
    },
  });

  const sendShareLink = async (email:string, message:string) => {
    setShareState('sending')
    const { recaptchaToken, recaptchaNumber } = await executeRecaptcha('download_kone_com')
    sendEmail(store, {emailTo: email, emailSubject:t('cad-share-subject'), emailMessage:message, shareLink:window.location.href, recaptchaToken, recaptchaNumber}).then( result => {
      if(result.status !== 'Error') {
        setShareState('ready')
      } else {
        setShareState('error')
      }
    })    
  }

  return (
    <>
    {/* <Modal
      className={styles.ContactModal}
      opened={true}
      withCloseButton={false}
      onClose={() => { }}
      centered
      overflow="inside"
    > */}

      { ( shareState !== 'ready') &&
        <>
          <LoadingOverlay visible={shareState === "sending"} />
          <form onSubmit={form.onSubmit((values) => {
            // TODO: Do real implementation
            // dispatch(appActions.setContactState("ready"))
            sendShareLink(values.email, values.message)        
          }) }>
            <Group direction="column" align="stretch" className={styles.EmailForm}>
              <Title order={3}>{t('ui-modal-email-share-link-header')}</Title>

              {shareState === 'error' &&
                <Alert icon={<InfoCircleRed />} color="red" mb={16}>
                  {t('ui-alert-failed-to-send-email')}
                </Alert>
              }

              <TextInput
                required
                label={t('ui-form-email')}
                placeholder={t('cad-form-email-placeholder')}
                {...form.getInputProps('email')}
                className={classes.inputFieldLabel}
              />

              <Textarea
                label={t('ui-form-message')}
                placeholder={t('ui-form-your-message')}
                {...form.getInputProps('message')}
                className={classes.inputFieldLabel}
              />

              <div className={styles.shareDesign}>
                <div className={styles.shareDesignIcon}>
                  <LinkComponet size={40} />
                </div>
                <div className={styles.shareDesignBody}>
                  <Title order={4} className={styles.uppercase}>{t('ui-main-page-share-design')}</Title>
                  <Text className={styles.shareLink}><a href={ window.location.href }>{ window.location.href }</a></Text>
                  <Text className={styles.shareInfo}>{t('ui-main-page-share-link-notice')}</Text>
                  <Text className={styles.shareInfo}>{t('ui-main-page-valid-label')} {validDate}</Text>
                </div>
              </div>

              <Text size="sm">
                {t('ui-contact-privacy-statement-1')}
                  <a
                    tabIndex={-1}
                    className="readMore"
                    href={domainCountry?.privacyStatement}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    &nbsp;
                    {t('ui-contact-privacy-statement-2')}
                  </a>
                {t('ui-contact-privacy-statement-3')}
              </Text>

              <Group position="right" spacing="sm" mb={1} >
                <Button onClick={onCancel} variant="outline" className={classes.formButton}>{t("ui-general-back")}</Button>
                <Button type="submit" className={classes.formButton}>{t("ui-general-send")}</Button>
              </Group>
            </Group>
            {/* <LoadingOverlay visible={contactState === "waiting"} /> */}
          </form>
        </>
      }
      {shareState === 'ready' &&
        <Group direction="column" align="stretch" className={styles.EmailForm}>
          <Title order={3}>{t('ui-modal-email-sent')}</Title>
          <Group position="right" spacing="sm" mb={1} >
            <Button onClick={onCancel} variant="outline" className={classes.formButton}>{t("ui-general-ok")}</Button>
          </Group>
        </Group>
      }
    {/* </Modal> */}
    </>
  );
}

export default EmailForm;